import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { ApplicationContext } from '../../context/GlobalState';
import { t, extractLocaleFromPath } from '../../i18n';
import doctors from '../../data/team/doctors.json';

function DoctorCard({ doctor }) {
  return (
    <div className="glass-card doctor-card" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 0,
      overflow: 'hidden',
      borderRadius: 16,
    }}>
      <div style={{
        width: '100%',
        paddingTop: '75%',
        position: 'relative',
        background: 'var(--glass-bg, rgba(255,255,255,0.08))',
        overflow: 'hidden',
      }}>
        <img
          src={doctor.photo}
          alt={doctor.name}
          onError={(e) => { e.target.style.display = 'none'; }}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'top center',
          }}
        />
      </div>
      <div style={{ padding: '16px 20px', textAlign: 'center', flex: 1 }}>
        <h3 style={{ margin: '0 0 4px', fontSize: '1.1rem', fontWeight: 700 }}>{doctor.name}</h3>
        <p style={{ margin: '0 0 4px', fontSize: '0.9rem', color: 'var(--color-accent)', fontWeight: 600 }}>{doctor.title}</p>
        <p style={{ margin: 0, fontSize: '0.8rem', color: 'var(--color-text-secondary)', opacity: 0.8 }}>{doctor.board}</p>
      </div>
    </div>
  );
}

export default function AboutUs() {
  const { state } = useContext(ApplicationContext);
  const location = useLocation();
  const { locale } = extractLocaleFromPath(location.pathname);
  const brand = state.brand;
  const brandKey = brand.brandKey || 'gso';

  // Filter doctors by site
  const brandDoctors = doctors.filter(d => {
    if (brandKey === 'gso') return d.site === 'gso';
    if (brandKey === 'apex-nc') return d.site === 'apex';
    // apex-tn: show all
    return true;
  });

  return (
    <div className="about-page">
      <section className="glass-dark" style={{ padding: '80px 0', textAlign: 'center', borderRadius: 0, marginBottom: 40 }}>
        <div className="container">
          <h1 style={{ fontSize: '2.8rem', fontWeight: 800 }}>About {brand.name}</h1>
          <p style={{ opacity: 0.9, maxWidth: 600, margin: '12px auto' }}>Comprehensive Orthopedic, Spine &amp; Injury Care</p>
        </div>
      </section>

      <section className="container" style={{ maxWidth: 900, margin: '0 auto', padding: '0 20px 40px' }}>
        <div className="glass-panel" style={{ padding: 32, marginBottom: 24 }}>
          <h2>{t('section.whyChooseUs', locale, { clientName: brand.shortName })}</h2>
          <p style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8 }}>
            {brand.name} is a leading orthopedic and spine care practice serving patients across {brand.state}. Our team of board-certified orthopedic surgeons, spine specialists, neurologists, and rehabilitation experts provides comprehensive care for injuries and conditions affecting the musculoskeletal and nervous systems.
          </p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 16 }}>
          <div className="glass-stat"><div className="glass-stat-number">20+</div><div className="glass-stat-label">{t('trust.experience', locale)}</div></div>
          <div className="glass-stat"><div className="glass-stat-number">{brand.locations?.length || 0}</div><div className="glass-stat-label">Locations</div></div>
          <div className="glass-stat"><div className="glass-stat-number">5,000+</div><div className="glass-stat-label">Patients Treated</div></div>
          <div className="glass-stat"><div className="glass-stat-number">6</div><div className="glass-stat-label">Languages</div></div>
        </div>
      </section>

      {/* Meet Our Team */}
      <section className="container" style={{ maxWidth: 1100, margin: '0 auto', padding: '0 20px 80px' }}>
        <h2 style={{ textAlign: 'center', marginBottom: 32, fontSize: '2rem', fontWeight: 800 }}>Meet Our Team</h2>
        {brandDoctors.length === 0 ? (
          <div className="glass-panel" style={{ padding: 40, textAlign: 'center' }}>
            <p style={{ color: 'var(--color-text-secondary)' }}>Our team information is coming soon.</p>
          </div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
            gap: 24,
          }}>
            {brandDoctors.map(doc => (
              <DoctorCard key={doc.id} doctor={doc} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
